import { Link } from 'react-router-dom';

const PropertyCard = ({ property }) => {
    // Handle case where property might be undefined
    if (!property) return null;

    // Extract key property details
    const { 
        propertyTitle, 
        location, 
        amenities = [], 
        coverImageUrl, 
        images = [], 
        startPrice,
        highlights = []
    } = property;

    // Get top highlights to display (limited to 2)
    const topHighlights = highlights.slice(0, 2);
    
    // Get top amenities to display (limited to 5)
    const topAmenities = amenities.slice(0, 5);

    return (
        <div className="villa-card-wrapper">
            <Link to={`/property/${property.id}`} className="card-link">
                <div className="villa-card">
                    <div className="row g-0">
                        <div className="col-md-5">
                            <div className="villa-img-container">
                                <div className="location-badge">{location}</div>
                                <img 
                                    src={coverImageUrl || images[0] || "https://via.placeholder.com/300x200?text=No+Image"} 
                                    className="villa-img" 
                                    alt={propertyTitle} 
                                />
                                {images.length > 1 && (
                                    <>
                                        <div className="nav-arrow left">
                                            <i className="fas fa-chevron-left" />
                                        </div>
                                        <div className="nav-arrow right">
                                            <i className="fas fa-chevron-right" />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="villa-details">
                                <div className="content-wrapper">
                                    <h2 className="villa-title">{propertyTitle}</h2>
                                    <p className="villa-location">
                                        <i className="fas fa-map-marker-alt me-2" /> {location}, Maharashtra
                                    </p>
                                    <div className="villa-features">
                                        {topAmenities.map((amenity, index) => (
                                            <span key={index}>
                                                <span className="feature-item">{amenity}</span>
                                                {index < topAmenities.length - 1 && " • "}
                                            </span>
                                        ))}
                                    </div>
                                    {topHighlights.map((highlight, index) => (
                                        <div key={index} className="highlight-feature">
                                            <i className="fas fa-check-circle check-icon" /> {highlight}
                                        </div>
                                    ))}
                                </div>
                                <div className="card-footer d-flex justify-content-between align-items-center mt-auto">
                                    <div className="price-container">
                                        <div className="villa-price">
                                            ₹ {startPrice?.toLocaleString() || "Price on request"}
                                        </div>
                                        <div className="price-starting">Starts from</div>
                                    </div>
                                    <div className="btn btn-dark view-details-btn">View Details</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
}

export default PropertyCard;
